import classNames from 'classnames';
import * as React from 'react';
const PICTOGRAM_SIZE_UNIT = 64;
/**
 * Pictogram icons are designed to provide contextual information. At 64x64 px, they are the
 * mid-range of our icon set. At this size, Pictograms have slightly more detail than
 * UI icons. They aren’t clickable.
 *
 * Example uses: feature education, admin console, presentations, sales and marketing assets
 *
 * See
 * [drl/dig/library/components/icons](https://dbx.link/dig/library/components/icons)
 * for more details.
 */
export const PictogramIcon = ({ className, 
// `src` is aliased as `IconComponent` for usage in JSX
src: IconComponent, ...rest }) => {
    const cls = classNames('dig-PictogramIcon', className);
    const isPresentation = !rest['aria-label'] && !rest['aria-labelledby'];
    return (React.createElement(IconComponent, { className: cls, width: PICTOGRAM_SIZE_UNIT, height: PICTOGRAM_SIZE_UNIT, focusable: "false", role: isPresentation ? 'presentation' : undefined, ...rest }));
};
PictogramIcon.displayName = 'PictogramIcon';
